import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// Login Redux States
import { CHECK_LOGIN, LOGOUT_USER, VERIFY_ADMIN } from './actionTypes';
import { apiError, loginUserSuccessful, logoutUserSuccess, verify_adminFail, verify_adminSuccess } from './actions';
import { push } from 'connected-react-router'; // Import the push function from connected-react-router

// AUTH related methods
import { loginApi, logoutApi, verifyAdminApi } from './api';

//If user is login then dispatch redux action's are directly from here.

function* loginUser({ payload: { user, history } }) {
    try {
        const response = yield call(loginApi, user)
        // localStorage.setItem("authUser", JSON.stringify(response.data.profile));
        localStorage.setItem("token", JSON.stringify(response.data.token));
        yield put(loginUserSuccessful(response));

        history('/dashboard');
    } catch (error) {
        yield put(apiError(error));
    }
}

function* logoutUser({ payload: { history } }) {
    try {

        const response = yield call(logoutApi);
        yield put(logoutUserSuccess(response));
        localStorage.removeItem('token');
        history('/login');
    } catch (error) {
        // yield put(apiError(error));
        localStorage.removeItem('token');
        history('/login');
    }
}

function* verifyAdmin({ payload: { history } }) {
    try {
        const response = yield call(verifyAdminApi);
        if (response.code === "success") {
            yield put(verify_adminSuccess(response));
        } else {
            localStorage.removeItem('token');
            yield put(verify_adminFail(response));
            yield put(apiError(response));
            return false
        }
    } catch (error) {
        localStorage.removeItem('token');
        yield put(verify_adminFail({data:error}));
        yield put(apiError(error));
        
    }
}

export function* watchUserLogin() {
    yield takeEvery(CHECK_LOGIN, loginUser);
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUser);
}

function* loginSaga() {
    yield all([
        fork(watchUserLogin),
        fork(watchUserLogout),
    ]);
    yield takeEvery(VERIFY_ADMIN, verifyAdmin)

}

export default loginSaga;